import { ReactElement } from 'react';
import Toast from '../Toast';
import { observer } from 'mobx-react';

import toastsModel from '../../models/toasts';

import './styles.scss';

function ToastManager(): ReactElement {
  const { toasts } = toastsModel;

  function onClose(toastId: string): void {
    for (let i = 0; i < toasts.length; i += 1) {
      if (toasts[i].id === toastId) {
        toasts.splice(i, 1);
        break;
      }
    }
  }

  const toastList = toasts.map(({ id, preset, text }) => (
    <Toast key={id} id={id} text={text} preset={preset} onClose={onClose} />
  ));

  return <div className="toast-manager">{toastList}</div>;
}

export default observer(ToastManager);
